import {
  getProjectStatusCode,
  ProjectStatus
} from "./../models/project-status";
import { client } from "@/api/request";

export interface CountProjectsQuery {
  status: ProjectStatus;
}

export interface CountProjectsResponse {
  projectsCount: number;
}

/**
 * 現場の件数を調べる
 */
export async function countProjects(
  query: CountProjectsQuery
): Promise<CountProjectsResponse> {
  return await client.get("count_projects.php", {
    status: query.status ? getProjectStatusCode(query.status) : undefined
  });
}
